import { WeaponType } from '../weapons/Weapon';

export class HUD {
  private healthFill: HTMLElement;
  private healthText: HTMLElement;
  private scoreElement: HTMLElement;
  private levelElement: HTMLElement;
  private enemiesElement: HTMLElement;
  private shieldIndicator: HTMLElement | null = null;
  private weaponNameElement: HTMLElement | null = null;
  private ammoElement: HTMLElement | null = null;

  constructor() {
    this.healthFill = document.getElementById('health-fill')!;
    this.healthText = document.getElementById('health-text')!;
    this.scoreElement = document.getElementById('score')!;
    this.levelElement = document.getElementById('level')!;
    this.enemiesElement = document.getElementById('enemies')!;

    // 创建护盾指示器
    this.createShieldIndicator();

    // 创建武器信息显示
    this.createWeaponDisplay();
  }

  private createShieldIndicator(): void {
    const hudElement = document.getElementById('hud')!;
    this.shieldIndicator = document.createElement('div');
    this.shieldIndicator.id = 'shield-indicator';
    this.shieldIndicator.style.cssText = `
      position: absolute;
      bottom: 20px;
      left: 20px;
      padding: 10px 20px;
      background: rgba(0, 255, 255, 0.3);
      border: 2px solid #00ffff;
      border-radius: 5px;
      font-size: 18px;
      font-weight: bold;
      color: #00ffff;
      display: none;
    `;
    this.shieldIndicator.textContent = '护盾激活';
    hudElement.appendChild(this.shieldIndicator);
  }

  private createWeaponDisplay(): void {
    const hudElement = document.getElementById('hud')!;

    // 武器名称
    this.weaponNameElement = document.createElement('div');
    this.weaponNameElement.id = 'weapon-name';
    this.weaponNameElement.style.cssText = `
      position: absolute;
      bottom: 80px;
      left: 20px;
      padding: 8px 16px;
      background: rgba(0, 0, 0, 0.5);
      border: 2px solid #ffa500;
      border-radius: 5px;
      font-size: 16px;
      font-weight: bold;
      color: #ffa500;
    `;
    hudElement.appendChild(this.weaponNameElement);

    // 弹药显示
    this.ammoElement = document.createElement('div');
    this.ammoElement.id = 'ammo';
    this.ammoElement.style.cssText = `
      position: absolute;
      bottom: 120px;
      left: 20px;
      padding: 6px 14px;
      background: rgba(0, 0, 0, 0.5);
      border: 2px solid #ffff00;
      border-radius: 5px;
      font-size: 14px;
      color: #ffff00;
    `;
    hudElement.appendChild(this.ammoElement);

    // 添加提示文本
    const hintElement = document.createElement('div');
    hintElement.style.cssText = `
      position: absolute;
      bottom: 160px;
      left: 20px;
      padding: 6px 14px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 5px;
      font-size: 12px;
      color: #aaa;
    `;
    hintElement.textContent = '按1-4切换武器';
    hudElement.appendChild(hintElement);
  }

  updateHealth(current: number, max: number): void {
    const percentage = (current / max) * 100;
    this.healthFill.style.width = `${percentage}%`;
    this.healthText.textContent = `${Math.max(0, Math.round(current))}/${max}`;
  }

  updateScore(score: number): void {
    this.scoreElement.textContent = score.toString();
  }

  updateLevel(level: number): void {
    this.levelElement.textContent = `关卡: ${level}`;
  }

  updateEnemies(count: number): void {
    this.enemiesElement.textContent = count.toString();
  }

  updateShield(hasShield: boolean, time: number): void {
    if (!this.shieldIndicator) return;

    if (hasShield) {
      this.shieldIndicator.style.display = 'block';
      this.shieldIndicator.textContent = `护盾: ${time.toFixed(1)}s`;
    } else {
      this.shieldIndicator.style.display = 'none';
    }
  }

  updateWeapon(weaponType: WeaponType, ammo: number, maxAmmo: number): void {
    const weaponNames: Record<WeaponType, string> = {
      cannon: '主炮',
      machinegun: '机枪',
      missile: '导弹',
      mine: '地雷'
    };

    if (this.weaponNameElement) {
      this.weaponNameElement.textContent = `武器: ${weaponNames[weaponType]}`;
    }

    if (this.ammoElement) {
      if (maxAmmo === -1) {
        this.ammoElement.textContent = '弹药: ∞';
      } else {
        this.ammoElement.textContent = `弹药: ${ammo}/${maxAmmo}`;
        // 根据弹药量改变颜色
        if (ammo === 0) {
          this.ammoElement.style.color = '#ff0000';
          this.ammoElement.style.borderColor = '#ff0000';
        } else if (ammo < maxAmmo * 0.3) {
          this.ammoElement.style.color = '#ffaa00';
          this.ammoElement.style.borderColor = '#ffaa00';
        } else {
          this.ammoElement.style.color = '#ffff00';
          this.ammoElement.style.borderColor = '#ffff00';
        }
      }
    }
  }

  showGameOver(won: boolean, score: number): void {
    const overlay = document.getElementById('game-overlay')!;
    const message = document.getElementById('overlay-message')!;
    const button = document.getElementById('start-button')!;

    if (won) {
      message.textContent = `恭喜通关！最终分数: ${score}`;
      button.textContent = '下一关';
    } else {
      message.textContent = `游戏结束！最终分数: ${score}`;
      button.textContent = '重新开始';
    }

    overlay.classList.remove('hidden');
  }
}
